import moment from 'moment';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { getFormattedDate } from 'dashboard/reducers/announcements/utils';
import { addAnnouncement, deleteAnnouncement, fetchAnnouncements } from 'dashboard/actions/announcements/announcements.actions';
import editTemplate from './announcement-form.html';

const DIRTY_FORM = 'announcementEdit';
const DIRTY_ANNOUNCEMENTS_FORM = 'announcementsManagement';

const mapStateToThis = ({ session, announcements, config, ui }) => {
  const { locale, serverTime } = session;
  const { active, archived, scheduled } = announcements;
  const { locales, announcementsTitleMaxLength } = config;
  const { selectedLanguage } = ui;

  return {
    locale,
    locales,
    serverTime,
    active,
    archived,
    scheduled,
    announcementsTitleMaxLength,
    selectedLanguage,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  fetchAnnouncements,
  addAnnouncement,
  deleteAnnouncement,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', '$scope', 'Notifications', 'gettextCatalog', 'Responsive')
class AnnouncementFormController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.DIRTY_FORM = DIRTY_FORM;
    this.index = this.$state.params.id;
    this.type = this.$state.params.type;
    this.announcementModel = {
      fields: {},
      attachments: {},
      publishFrom: moment.unix(this.serverTime).utc().format('MM/DD/YYYY'),
    };

    if (this.index && this.type) {
      if (!this[this.type][this.index]) {
        await this.fetchAnnouncements(false);
      }
      this.getAnnouncementDetails();
    }
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getAnnouncementDetails() {
    const { publishFrom, publishTo, ...details } = this[this.type][this.index];
    this.announcementModel = {
      ...details,
      publishFrom: getFormattedDate(publishFrom),
      publishTo: getFormattedDate(publishTo),
    };
  }

  saveAnnouncement(form) {
    form.$setSubmitted();
    if (form.$valid) {
      if (this.verifyOtherLanguages()) {
        this.Notifications.alertWarning(this.gettextCatalog.getString('Enter other language before submitting.'));
        return;
      }
      this.dateFutureError = this.verifyDateFuture();
      if (this.fileErrors || this.dateFutureError) {
        return;
      }

      if (this.index) {
        this.deleteAnnouncement(this.index, this.type);
      }
      this.addAnnouncement(this.announcementModel);
      this.setDirtyForm(DIRTY_ANNOUNCEMENTS_FORM, true);
      this.$state.go('cms-newsManagement', { skipReloadData: true, skipDirtyForms: true });
    }
  }

  verifyOtherLanguages() {
    let otherLanguageError = false;
    this.locales.forEach((locale) => {
      if (!this.announcementModel.fields[locale.code]) {
        otherLanguageError = true;
      }
    });
    return otherLanguageError;
  }

  verifyDateFuture() {
    const publishTo = this.announcementModel.publishTo ? moment(this.announcementModel.publishTo).utc().format('x') : undefined;
    const serverTime = moment.unix(this.serverTime).utc().startOf('day').format('x');

    return publishTo ? publishTo < serverTime : false;
  }

  cancel() {
    this.$state.go('cms-newsManagement', { skipReloadData: true });
  }
}

export default class AnnouncementFormComponent {
  constructor() {
    this.controller = AnnouncementFormController;
    this.template = editTemplate;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/announcement-form/announcement-form-component.js